import _styled from "styled-components";
import React from 'react';
import { useVisibilityObserver } from '@noths/polaris-client-react-hooks';
import { grid } from '@noths/polaris-client-ribbons-base';
import { ContentTile } from "./ContentTile";
import { ContentTileAspectRatioSizes } from "./ContentTileAspectRatioSizes";
import { getImgSourcesByBreakpoint } from "./utils";
import * as styles from "./ContentTiles.styles";
export var ContentTiles = function ContentTiles(_ref) {
  var onTileClick = _ref.onTileClick,
    _ref$onVisible = _ref.onVisible,
    onVisible = _ref$onVisible === void 0 ? function () {} : _ref$onVisible,
    tiles = _ref.tiles;
  var _useVisibilityObserve = useVisibilityObserver(function () {
      return onVisible();
    }),
    observedElementRef = _useVisibilityObserve.observedElementRef;
  var isFourTileLayout = tiles.length !== 2;
  var aspectRatioLayoutStyle = isFourTileLayout ? ContentTileAspectRatioSizes.fourTileLayout : ContentTileAspectRatioSizes.twoTileLayout;
  return /*#__PURE__*/React.createElement(_StyledDiv, {
    ref: observedElementRef,
    $_css: [grid, styles.grid]
  }, tiles.map(function (_ref2, index) {
    var backgroundColor = _ref2.backgroundColor,
      href = _ref2.href,
      imageSrc = _ref2.imageSrc,
      title = _ref2.title;
    var imgSourcesByBreakpoint = getImgSourcesByBreakpoint(imageSrc, aspectRatioLayoutStyle);
    return /*#__PURE__*/React.createElement(ContentTile, {
      backgroundColor: backgroundColor,
      href: href,
      imgSourcesByBreakpoint: imgSourcesByBreakpoint,
      isFourTileLayout: isFourTileLayout,
      key: href,
      onClick: function onClick(e) {
        return onTileClick === null || onTileClick === void 0 ? void 0 : onTileClick(e, {
          index
        });
      },
      title: title
    });
  }));
};
var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  displayName: "ContentTiles___StyledDiv",
  componentId: "sc-p7jo4i-0"
})(["", ""], function (p) {
  return p.$_css;
});